import { motion } from "framer-motion";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import teachingData from "./teaching.json";

export const Teaching = () => {

const teachingJobs = teachingData.teachingJobs;

  return (
    <Container>

      <h3
        style={{
          marginTop: "30px",
          marginBottom: "30px",
        }}
      >
        Teaching roles
      </h3>



      <div className="publications-container">
        {teachingJobs.map((job, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6 }}
          >
            <Card>
              <Card.Header className="bold">
                {job.role} - {job.institution.name}, {job.institution.location}
              </Card.Header>

              <Card.Body>
                {job.courses.map((course, j) => (
                  <div key={j} style={{ marginTop: "1rem" }}>
                    <h5 className="bold">
                      {course.courseCode} – {course.courseTitle}
                    </h5>

                    {course.entries.map((entry, k) => (
                      <div key={k} style={{ marginBottom: "1rem" }}>
                        <span className="fw-bold">
                          {entry.term}
                        </span>

                        {entry.students && (
                          <span className="muted-text">
                            {" "}({entry.students} students)
                          </span>
                        )}

                        <ul>
                          {entry.responsibilities.map((r, idx) => (
                            <li key={idx}>{r}</li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                ))}
              </Card.Body>
            </Card>
          </motion.div>
        ))}
      </div>



    </Container>
  );
};
